import React, { useState, useEffect } from "react";
import axios from "axios";
import ClientList from "./ClientList";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ConfirmDialog from "./ConfirmDialog";
import PrintJobsheet from "./PrintJobsheet";
import AddCustomerModal from "./AddCustomerModal";

const API = "https://eps.elkomprintama.com/";

const inp =
  "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:border-green-400 focus:ring-1 focus:ring-green-200 transition";
const inpDisabled =
  "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-gray-100 text-gray-400 cursor-not-allowed";
const lbl =
  "block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1";

const TABS = ["Header", "Material", "Process", "Other"];

const NewJobsheet = () => {
  const { user } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState(0);
  const [showConfirm, setShowConfirm] = useState(false);
  const [printJob, setPrintJob] = useState(null);
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [materials, setMaterials] = useState([]);

  const [custId, setCustId] = useState(null);
  const [jobDate, setJobDate] = useState(new Date());
  const [jobName, setJobName] = useState("");
  const [matId, setMatId] = useState("");
  const [matClr, setMatClr] = useState("");
  const [size, setSize] = useState("");
  const [ptg, setPtg] = useState("");
  const [pnCust, setPnCust] = useState("");
  const [mpnElk, setMpnElk] = useState("");
  const [drwNo, setDrwNo] = useState("");
  const [dieNo, setDieNo] = useState("");
  const [roll, setRoll] = useState("");
  const [core, setCore] = useState("");
  const [flw, setFlw] = useState("Face In");
  const [sht, setSht] = useState("");
  const [cmpLabel, setCmpLabel] = useState("");
  const [stdPack, setStdPack] = useState("");
  const [pefo, setPefo] = useState("");
  const [required, setRequired] = useState("");
  const [lami, setLami] = useState("");
  const [note, setNote] = useState("");

  // Roll/Sheet & laminate
  const [rollMode, setRollMode] = useState("roll");
  const [hasLaminate, setHasLaminate] = useState(false);
  const [matSizes, setMatSizes] = useState([]);
  const [lamiSizes, setLamiSizes] = useState([]);
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [clientRefreshKey, setClientRefreshKey] = useState(0);

  useEffect(() => {
    axios
      .get(`${API}get/api/mat-sizes/4`, { withCredentials: true })
      .then((r) => setLamiSizes(r.data?.result || []))
      .catch(() => setLamiSizes([]));
  }, []);

  useEffect(() => {
    if (!matId) {
      setMatSizes([]);
      setRequired("");
      return;
    }
    axios
      .get(`${API}get/api/mat-sizes/${matId}`, { withCredentials: true })
      .then((r) => setMatSizes(r.data?.result || []))
      .catch(() => setMatSizes([]));
  }, [matId]);

  useEffect(() => {
    axios
      .get(`${API}get/api/materials`, { withCredentials: true })
      .then((r) => setMaterials(r.data?.result || []))
      .catch(() => {});
  }, []);

  const reset = () => {
    setCustId(null);
    setJobDate(new Date());
    setJobName("");
    setMatId("");
    setMatClr("");
    setSize("");
    setPtg("");
    setPnCust("");
    setMpnElk("");
    setDrwNo("");
    setDieNo("");
    setRoll("");
    setCore("");
    setFlw("Face In");
    setSht("");
    setCmpLabel("");
    setStdPack("");
    setPefo("");
    setRequired("");
    setLami("");
    setNote("");
    setRollMode("roll");
    setHasLaminate(false);
    setMatSizes([]);
    setActiveTab(0);
  };

  const handleRollMode = (mode) => {
    setRollMode(mode);
    if (mode === "roll") {
      setSht("-");
      setCmpLabel("-");
    } else {
      setRoll("-");
      setCore("-");
      setFlw("");
    }
  };

  const handleCreate = async () => {
    const isRoll = rollMode === "roll";
    const submitRoll = isRoll ? roll : "-";
    const submitCore = isRoll ? core : "-";
    const submitFlw = isRoll ? flw : "";
    const submitSht = isRoll ? "-" : sht;
    const submitCmpLabel = isRoll ? "-" : cmpLabel;
    try {
      const res = await axios.post(`${API}post/api/jobsheet`, {
        cust_id: custId,
        job_date: format(jobDate, "yyyy-MM-dd"),
        job_name: jobName,
        mat_id: matId || null,
        mat_clr: matClr,
        size,
        ptg,
        pn_cust: pnCust,
        mpn_elk: mpnElk,
        drw_no: drwNo,
        die_no: dieNo,
        roll: submitRoll,
        core: submitCore,
        flw: submitFlw,
        sht: submitSht,
        cmp_label: submitCmpLabel,
        std_pack: stdPack,
        pefo,
        required,
        lami,
        note,
        admin: user?.username || "",
      });
      toast.success("Jobsheet created!");
      const selectedMat = materials.find(
        (m) => String(m.mat_id) === String(matId),
      );
      setPrintJob({
        job_id: res.data.job_id,
        job_date: jobDate,
        nme: "",
        job_name: jobName,
        mat_name: selectedMat?.mat_name || "",
        mat_clr: matClr,
        size,
        ptg,
        pn_cust: pnCust,
        mpn_elk: mpnElk,
        drw_no: drwNo,
        die_no: dieNo,
        roll: submitRoll,
        core: submitCore,
        flw: submitFlw,
        sht: submitSht,
        cmp_label: submitCmpLabel,
        std_pack: stdPack,
        pefo,
        required,
        lami,
        note,
        product_code: null,
        admin: user?.username || "",
      });
      setShowPrintDialog(true);
      reset();
    } catch (err) {
      toast.error(err?.response?.data?.msg || "Failed to create jobsheet.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!custId) {
      toast.error("Please select a customer.");
      return;
    }
    if (!jobName.trim()) {
      toast.error("Description is required.");
      return;
    }
    setShowConfirm(true);
  };

  return (
    <>
      <div className="w-full rounded-lg bg-green-600 mb-4">
        <label className="block uppercase text-white mb-2 tracking-wide text-5xl text-center font-bold">
          New Jobsheet
        </label>
      </div>

      <div className="bg-white shadow-md rounded-xl border border-gray-200 flex flex-col">
        {/* Tab bar */}
        <div className="flex border-b border-gray-200 px-4 pt-3 gap-1">
          {TABS.map((tab, i) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2 text-sm font-semibold rounded-t-lg transition focus:outline-none ${
                activeTab === i
                  ? "bg-green-600 text-white"
                  : "text-gray-500 hover:text-green-600 hover:bg-green-50"
              }`}
            >
              {i + 1}. {tab}
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="px-6 py-5">
            {/* Tab 1: Header */}
            {activeTab === 0 && (
              <div className="space-y-4">
                <div>
                  <label className={lbl}>
                    Customer <span className="text-red-400">*</span>
                  </label>
                  <div className="flex gap-2 items-center">
                    <div className="flex-1">
                      <ClientList
                        onChangeList={setCustId}
                        onInitial={setCustId}
                        showLabel={false}
                        refreshKey={clientRefreshKey}
                      />
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowAddCustomer(true)}
                      className="flex-shrink-0 h-9 w-9 flex items-center justify-center rounded-lg border border-gray-300 bg-white hover:bg-indigo-50 hover:border-indigo-400 text-gray-500 hover:text-indigo-600 text-xl font-bold transition"
                      title="Add new customer"
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className={lbl}>Date</label>
                    <DatePicker
                      className={inp}
                      wrapperClassName="w-full"
                      selected={jobDate}
                      onChange={setJobDate}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className={lbl}>
                      Description <span className="text-red-400">*</span>
                    </label>
                    <input
                      className={inp}
                      name="jobname" type="text"
                      placeholder="Job description"
                      value={jobName}
                      onChange={(e) => setJobName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className={lbl}>Cust. P/N</label>
                    <input
                      className={inp}
                      name="pncust" type="text"
                      placeholder="Part number"
                      value={pnCust}
                      onChange={(e) => setPnCust(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className={lbl}>MPN (Elkom)</label>
                    <input
                      className={inp}
                      name="mpnelk" type="text"
                      placeholder="MPN"
                      value={mpnElk}
                      onChange={(e) => setMpnElk(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Tab 2: Material */}
            {activeTab === 1 && (
              <div className="space-y-4">
                <div>
                  <label className={lbl}>
                    Material <span className="text-red-400">*</span>
                  </label>
                  <div className="flex items-center gap-3">
                    <select
                      className={`${inp} flex-1`}
                      value={matId}
                      onChange={(e) => {
                        setMatId(e.target.value);
                        setRequired("");
                      }}
                    >
                      <option value="">— Select material —</option>
                      {materials.map((m) => (
                        <option key={m.mat_id} value={m.mat_id}>
                          {m.mat_name}
                        </option>
                      ))}
                    </select>
                    <label className="flex items-center gap-1.5 cursor-pointer whitespace-nowrap text-sm font-semibold text-green-700 select-none">
                      <input
                        type="checkbox"
                        checked={hasLaminate}
                        onChange={(e) => {
                          setHasLaminate(e.target.checked);
                          if (!e.target.checked) setLami("");
                        }}
                        className="w-4 h-4 rounded accent-green-600"
                      />
                      + LAMINATE
                    </label>
                  </div>
                </div>

                <div>
                  <label className={lbl}>Material Requirement</label>
                  {matSizes.length > 0 ? (
                    <select
                      className={inp}
                      value={required}
                      onChange={(e) => setRequired(e.target.value)}
                    >
                      <option value="">— Select requirement —</option>
                      {matSizes.map((s, i) => (
                        <option key={i} value={s.mat_size}>
                          {s.mat_size}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      className={inpDisabled}
                      readOnly
                      disabled
                      placeholder={
                        matId ? "No sizes found" : "Select a material first"
                      }
                      value={required}
                    />
                  )}
                </div>

                {hasLaminate && (
                  <div>
                    <label className={lbl}>Lamination</label>
                    <select
                      className={inp}
                      value={lami}
                      onChange={(e) => setLami(e.target.value)}
                    >
                      <option value="">— Select lamination —</option>
                      {lamiSizes.map((s, i) => (
                        <option key={i} value={s.mat_size}>
                          {s.mat_size}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className={lbl}>Material Colour</label>
                    <input
                      className={inp}
                      name="matclr" type="text"
                      placeholder="Colour"
                      value={matClr}
                      onChange={(e) => setMatClr(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className={lbl}>Size</label>
                    <input
                      className={inp}
                      name="size" type="text"
                      placeholder="Size"
                      value={size}
                      onChange={(e) => setSize(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className={lbl}>Printing</label>
                    <input
                      className={inp}
                      name="ptg" type="text"
                      placeholder="Printing"
                      value={ptg}
                      onChange={(e) => setPtg(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Tab 3: Process */}
            {activeTab === 2 && (
              <div className="space-y-5">
                {/* Type toggle */}
                <div>
                  <label className={lbl}>Type</label>
                  <div className="flex mt-1 rounded-lg border border-gray-300 w-fit overflow-hidden">
                    <button
                      type="button"
                      onClick={() => handleRollMode("roll")}
                      className={`px-8 py-2 text-sm font-bold transition ${rollMode === "roll" ? "bg-green-600 text-white" : "bg-white text-gray-500 hover:bg-gray-50"}`}
                    >
                      Roll
                    </button>
                    <button
                      type="button"
                      onClick={() => handleRollMode("sheet")}
                      className={`px-8 py-2 text-sm font-bold transition border-l border-gray-300 ${rollMode === "sheet" ? "bg-green-600 text-white" : "bg-white text-gray-500 hover:bg-gray-50"}`}
                    >
                      Sheet
                    </button>
                  </div>
                </div>

                {/* Roll card */}
                <div
                  className={`rounded-xl border-2 p-4 transition-all ${rollMode === "roll" ? "border-green-300 bg-green-50" : "border-dashed border-gray-200 bg-gray-50 opacity-50 pointer-events-none"}`}
                >
                  <p className="text-xs font-bold uppercase tracking-widest text-green-700 mb-3">
                    Roll
                  </p>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className={lbl}>Roll</label>
                      <input
                        className={inp}
                        name="roll" type="text"
                        placeholder="Roll"
                        value={rollMode === "roll" ? roll : "-"}
                        onChange={(e) => setRoll(e.target.value)}
                      />
                    </div>
                    <div>
                      <label className={lbl}>Core</label>
                      <input
                        className={inp}
                        name="core" type="text"
                        placeholder="Core"
                        value={rollMode === "roll" ? core : "-"}
                        onChange={(e) => setCore(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <label className={lbl}>Flow Direction</label>
                    <div className="flex gap-2 mt-1">
                      {["Face In", "Face Out"].map((dir) => (
                        <button
                          key={dir}
                          type="button"
                          onClick={() => setFlw(dir)}
                          className={`px-5 py-1.5 rounded-lg border text-sm font-semibold transition ${flw === dir ? "bg-green-600 text-white border-green-600" : "bg-white text-gray-600 border-gray-300 hover:border-green-300"}`}
                        >
                          {dir}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Sheet card */}
                <div
                  className={`rounded-xl border-2 p-4 transition-all ${rollMode === "sheet" ? "border-green-300 bg-green-50" : "border-dashed border-gray-200 bg-gray-50 opacity-50 pointer-events-none"}`}
                >
                  <p className="text-xs font-bold uppercase tracking-widest text-green-700 mb-3">
                    Sheet
                  </p>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className={lbl}>Sheet</label>
                      <input
                        className={inp}
                        name="sht" type="text"
                        placeholder="Sheet"
                        value={rollMode === "sheet" ? sht : "-"}
                        onChange={(e) => setSht(e.target.value)}
                      />
                    </div>
                    <div>
                      <label className={lbl}>Computer Label</label>
                      <input
                        className={inp}
                        name="cmplabel" type="text"
                        placeholder="Comp. label"
                        value={rollMode === "sheet" ? cmpLabel : "-"}
                        onChange={(e) => setCmpLabel(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Drawing, Diecut & common fields */}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className={lbl}>Drawing No.</label>
                    <input
                      className={inp}
                      name="drwno" type="text"
                      placeholder="Drawing"
                      value={drwNo}
                      onChange={(e) => setDrwNo(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className={lbl}>Diecut No.</label>
                    <input
                      className={inp}
                      name="dieno" type="text"
                      placeholder="Diecut"
                      value={dieNo}
                      onChange={(e) => setDieNo(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className={lbl}>Packing</label>
                    <input
                      className={inp}
                      name="stdpack" type="text"
                      placeholder="Packing"
                      value={stdPack}
                      onChange={(e) => setStdPack(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className={lbl}>Perforation</label>
                    <div className="flex gap-2 mt-1">
                      <button
                        type="button"
                        onClick={() => setPefo("PEFORATED")}
                        className={`px-4 py-1.5 rounded-lg border text-xs font-bold transition ${pefo === "PEFORATED" ? "bg-green-600 text-white border-green-600" : "bg-white text-gray-600 border-gray-300 hover:border-green-300"}`}
                      >
                        PEFORATED
                      </button>
                      <button
                        type="button"
                        onClick={() => setPefo("-")}
                        className={`px-4 py-1.5 rounded-lg border text-xs font-bold transition ${pefo === "-" ? "bg-green-600 text-white border-green-600" : "bg-white text-gray-600 border-gray-300 hover:border-green-300"}`}
                      >
                        NO PEFORATED
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Tab 4: Other */}
            {activeTab === 3 && (
              <div className="space-y-4">
                <div>
                  <label className={lbl}>Note</label>
                  <textarea
                    className={`${inp} resize-none`}
                    rows={5}
                    placeholder="Notes..."
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="border-t border-gray-200 px-6 py-3 bg-gray-50 rounded-b-xl flex items-center justify-between">
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => setActiveTab((t) => Math.max(0, t - 1))}
                disabled={activeTab === 0}
                className="px-4 py-2 rounded-lg text-sm font-semibold text-gray-600 bg-white border border-gray-300 hover:bg-gray-100 disabled:opacity-30 transition"
              >
                ← Prev
              </button>
              <button
                type="button"
                onClick={() =>
                  setActiveTab((t) => Math.min(TABS.length - 1, t + 1))
                }
                disabled={activeTab === TABS.length - 1}
                className="px-4 py-2 rounded-lg text-sm font-semibold text-gray-600 bg-white border border-gray-300 hover:bg-gray-100 disabled:opacity-30 transition"
              >
                Next →
              </button>
            </div>
            {activeTab === TABS.length - 1 && (
              <button
                type="submit"
                className="px-8 py-2 rounded-lg text-sm font-bold text-white bg-green-600 hover:bg-green-700 transition"
              >
                Create Jobsheet
              </button>
            )}
          </div>
        </form>
      </div>

      {showConfirm && (
        <ConfirmDialog
          message="Create this jobsheet?"
          onConfirm={() => {
            setShowConfirm(false);
            handleCreate();
          }}
          onCancel={() => setShowConfirm(false)}
        />
      )}

      {/* Print prompt after create */}
      {showPrintDialog && printJob && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center">
            <div className="text-4xl mb-3">🖨️</div>
            <h3 className="text-base font-bold text-gray-800 mb-1">
              Jobsheet Created!
            </h3>
            <p className="text-sm text-gray-500 mb-1">
              Jobsheet{" "}
              <span className="font-bold text-green-600">
                #{printJob.job_id}
              </span>{" "}
              has been saved.
            </p>
            <p className="text-xs text-gray-400 mb-5">
              Do you want to print it now?
            </p>
            <div className="flex gap-3">
              <button
                className="flex-1 bg-green-600 hover:bg-green-700 text-white font-bold py-2.5 rounded-lg text-sm transition"
                onClick={() => {
                  setShowPrintDialog(false);
                }}
              >
                🖨️ Print
              </button>
              <button
                className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-2.5 rounded-lg text-sm transition"
                onClick={() => {
                  setShowPrintDialog(false);
                  setPrintJob(null);
                }}
              >
                Skip
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Triggers print window when dialog confirmed */}
      {!showPrintDialog && printJob && (
        <PrintJobsheet job={printJob} onDone={() => setPrintJob(null)} />
      )}

      {showAddCustomer && (
        <AddCustomerModal
          onClose={() => setShowAddCustomer(false)}
          onAdded={() => setClientRefreshKey((k) => k + 1)}
        />
      )}
    </>
  );
};

export default NewJobsheet;
